export const getKyxIconUrl = (name: string): string => `/assets/images/icons/kyx/${name}.svg`;
